"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalButton = exports.ModalComponent = void 0;
var modal_1 = require("./modal");
Object.defineProperty(exports, "ModalComponent", { enumerable: true, get: function () { return modal_1.ModalComponent; } });
var modal_button_1 = require("./modal-button");
Object.defineProperty(exports, "ModalButton", { enumerable: true, get: function () { return modal_button_1.ModalButton; } });
